import LegalDocumentPage from "./LegalDocumentPage";

export function WhatWeDo() {
  return <LegalDocumentPage documentKey="whatWeDo" />;
}

export function WhatWeDontDo() {
  return <LegalDocumentPage documentKey="whatWeDont" />;
}
